export const OrderedList = ({ color = "primary" }: { color?: string }) => {
  const getColor = `hsl(var(--${color}))`

  return (
    <svg
      viewBox="0 0 53 41"
      fill={getColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52.6651 2.0982H13.8625V6.66321H52.6651V2.0982Z"
        fill={getColor}
      />
      <path
        d="M52.6651 18.0757H13.8625V22.6407H52.6651V18.0757Z"
        fill={getColor}
      />
      <path
        d="M52.6651 34.0533H13.8625V38.6183H52.6651V34.0533Z"
        fill={getColor}
      />
      <path
        d="M3.00104 8.37511V1.47281L3.75598 2.22775H1.49116V0.825722H4.74818V8.37511H3.00104Z"
        fill={getColor}
      />
      <path
        d="M0.701645 24.21V23.0776L3.61355 20.3274C3.84363 20.1189 4.01259 19.932 4.12044 19.7666C4.22829 19.6013 4.30018 19.4503 4.33613 19.3137C4.37927 19.1771 4.40084 19.0512 4.40084 18.9362C4.40084 18.6342 4.29659 18.4041 4.08808 18.246C3.88677 18.0806 3.58839 17.9979 3.19294 17.9979C2.87659 17.9979 2.5818 18.059 2.30859 18.1813C2.04256 18.3035 1.81608 18.494 1.62914 18.7529L0.356531 17.9332C0.644126 17.5018 1.04676 17.1603 1.56443 16.9086C2.0821 16.657 2.67886 16.5312 3.35471 16.5312C3.91553 16.5312 4.40444 16.6246 4.82145 16.8116C5.24566 16.9913 5.5728 17.2466 5.80287 17.5773C6.04014 17.908 6.15877 18.3035 6.15877 18.7636C6.15877 19.0081 6.12642 19.2526 6.06171 19.497C6.00419 19.7343 5.88196 19.9859 5.69502 20.2519C5.51528 20.518 5.24925 20.8164 4.89695 21.1471L2.48114 23.4227L2.14681 22.7864H6.40682V24.21H0.701645Z"
        fill={getColor}
      />
      <path
        d="M3.21451 40.1743C2.68965 40.1743 2.16838 40.106 1.65071 39.9694C1.13304 39.8256 0.694455 39.6242 0.334961 39.3654L1.01441 38.0281C1.302 38.2366 1.63633 38.402 2.01739 38.5242C2.39846 38.6464 2.78312 38.7075 3.17137 38.7075C3.60996 38.7075 3.95507 38.6213 4.20672 38.4487C4.45836 38.2761 4.58419 38.0389 4.58419 37.7369C4.58419 37.4493 4.47274 37.2228 4.24986 37.0575C4.02697 36.8921 3.66747 36.8094 3.17137 36.8094H2.37329V35.6554L4.47634 33.272L4.67046 33.8975H0.71243V32.4955H5.997V33.6279L3.90474 36.0113L3.02038 35.5044H3.52727C4.45477 35.5044 5.15578 35.7129 5.63031 36.13C6.10485 36.547 6.34211 37.0826 6.34211 37.7369C6.34211 38.1611 6.23067 38.5601 6.00778 38.934C5.7849 39.3007 5.44338 39.5991 4.98322 39.8292C4.52307 40.0592 3.9335 40.1743 3.21451 40.1743Z"
        fill={getColor}
      />
    </svg>
  )
}
